<template>
  <button type="button" class="btn-remove" @click.stop="$emit('click')">
    <i class="icon icon-times"></i>
  </button>
</template>

<script>
export default {
  name: 'ButtonRemove'
};
</script>

<style lang="scss">
@import '../assets/styles/components/button-remove';
</style>
